import GBlogDetailHeader from './g-blog-detail-header.vue';

export default GBlogDetailHeader;
